import { createEffect, createSignal, For, onCleanup, Show, useContext } from 'solid-js';
import { Section } from '../../../grid-system/section/section';
import { Button } from '../../../ui-components/button/button';
import { Heading } from '../../../ui-components/heading/heading';
import { Checkbox } from '../../../ui-components/inputs/checkbox/checkbox';
import { FlexRow } from '../../../ui-components/utility-style-components/flex';
import { CrossIcon } from '../../icons-library/cross';
import { Portal } from 'solid-js/web';
import { NestedCategory, ProductsStoreAndMethods } from '../products-types';
import { AppContext } from '../../../app-context-provider/app-context-provider';
import decodeHtmlEntities from '../../../tools/decode-html-entities';


type MobileFilterModalProps = {
    closeModal: () => void;
    applyFiltersText: string;
    productCategoriesHeading: string;
    typesHeading: string;
    store: ProductsStoreAndMethods;
    clickHandlers: {
        handleOnClickArea: (area: string) => void;
        handleOnClickCategory: (category: NestedCategory) => void;
        handleOnClickType: (type: NestedCategory) => void;
        handleOnClickClearFilters: (e: any) => void;
    }
}

export const MobileFilterModal = (props: MobileFilterModalProps) => {
    const { localize } = useContext(AppContext);

    const [ inputRef, setInputRef ] = createSignal<HTMLInputElement | undefined>(undefined);

    createEffect(() => {
        if (!inputRef()) return;

        inputRef()!.tabIndex = -1;
        inputRef()!.focus();
        inputRef()!.tabIndex = 0;
    });

    const onKeyPress = (e: KeyboardEvent) => {
        if (e.key === 'Escape') {
            props.closeModal();
        }
    };

    document.addEventListener('keydown', onKeyPress);

    onCleanup(() => {
        document.removeEventListener('keydown', onKeyPress);
    });

    return (
        <Portal mount={document.getElementById('app')!}>
            <div
                class="mobile-filters-modal-container bg-white h-screen fixed left-0 right-0 z-[3] px-6"
                style={{ top: '6.43rem' }}
                onScroll={e => e.preventDefault()}
            >
                <Section
                    templateShorthand={[12]}
                    widthType={'bgFull'}
                    backgroundValue={'white'}
                    backgroundType={'color'}
                    heightType={'fill'}
                    customCss='border-radius: 1.07rem;'
                >
                    <div>
                        <FlexRow justifyContent='end'>
                            <CrossIcon size='small' onClick={props.closeModal} ariaLabel={localize('close', 'Close')} />
                        </FlexRow>

                        <div class="pb-2 border-b border-gray mb-6">
                            <Heading noBlockSpacing={true} tag='h3' variant='small'>
                                {props.productCategoriesHeading}
                            </Heading>
                        </div>
                        <ul class="mb-8">
                            <For each={props.store.store.availableProductCategories}>{(category, index) => (
                                <li>
                                    <Checkbox
                                        value={category?._data?.slug}
                                        inputRef={(el: HTMLInputElement) => index() === 0 && setInputRef(el)}
                                        whenClicked={() => props.clickHandlers.handleOnClickCategory(category)}
                                        name={decodeHtmlEntities(category?._data?.name)}
                                        isChecked={!!props.store.store?.selectedProductCategories?.find(existing => existing?._data?.slug === category?._data?.slug)}
                                    />
                                </li>
                            )}</For>
                        </ul>

                        <Show when={props.store.store?.availableTypes?.length > 0}>
                            <div class="pb-2 border-b border-gray mb-6">
                                <Heading noBlockSpacing={true} tag='h3' variant='small'>
                                    {props.typesHeading}
                                </Heading>
                            </div>
                            <ul class="mb-8">
                                <For each={props.store.store.availableTypes}>{(type) => (
                                    <li>
                                        <Checkbox
                                            value={type?._data?.slug}
                                            whenClicked={() => props.clickHandlers.handleOnClickType(type)}
                                            name={decodeHtmlEntities(type?._data?.name)}
                                            isChecked={!!props.store.store.selectedTypes?.find(existing => existing?._data?.slug === type?._data?.slug)}
                                        />
                                    </li>
                                )}</For>
                            </ul>
                        </Show>

                        <FlexRow justifyContent='center'>
                            <Button label={props.applyFiltersText} onClick={props.closeModal} />
                        </FlexRow>
                    </div>
                </Section>
            </div>
        </Portal>
    );
};
